let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fy72i")).then(() => parcelRequire('aR7pU'));